import Module from './newFooter'
export default Module
